/**
 * Default start state for the simulated GNSS feed in the live app.
 *
 * Picked so the boat acquires a fix inside the charted area with no panning:
 * open water (10 to 20 m) among the anchorage and harbour markers in cell
 * GB4RYA4F, near the centre of the overview the chart opens on. A gentle heading
 * and speed keep it on screen rather than shooting off the edge.
 *
 * Change these to move the demo vessel. To go back to an empty chart until a
 * boat is placed, flip the sim store `running` default to false.
 */
export const DEFAULT_SIM_START = {
  /** [lon, lat] WGS84. Open water near the anchorages in GB4RYA4F. */
  position: [-5.83, 46.215] as [number, number],
  /** Heading through the water, degrees true. */
  headingDeg: 60,
  /** Speed through the water, knots. */
  stwKn: 3.5,
};
